import WhyBnB from "pages/LandingPages/WhyBnB";
export default function whyBnB() {
  return <WhyBnB />;
}
